<template>
  <ve-table style="width: 100%;" :scroll-width="scrollWidth" :columns="columns" :table-data="tableData"
    row-key-field-name="keyName" :rowStyleOption="{ stripe: true }" />
</template>
<script>
import { mapGetters } from 'vuex'
import { formatMoney } from '@/util'

export default {
  props: {
    scrollWidth: {
      type: Number,
      require: true
    },
    keyName: {
      type: String,
      require: true
    },
    tableData: {
      type: Array,
      require: true,
      default() {
        return []
      }
    }
  },
  computed: {
    ...mapGetters([
      'achievementRate'
    ]),
    columns() {
      return [
        {
          field: '',
          key: 'expand',
          title: '',
          width: 30,
          align: 'center',
          fixed: 'left',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row.isLeaf ? '' : h('div', {
              style: {
                'font-size': '16px',
                position: 'relative',
                top: '-2px'
              },
              on: {
                click: () => {
                  this.$emit('on-expand', row, rowIndex)
                }
              }
            }, row.canExpand ? (row.isExpand ? '-' : '+') : '')
          }
        },
        {
          title: '名单供应商',
          key: 'namesSupplier',
          tree: true,
          fixed: 'left',
          align: 'left',
          width: 90,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('span', {
              style: {
                position: 'relative',
                left: row.isLeaf ? '10px' : 0
              }
            }, row.namesSupplier || '未知')
          }
        },
        {
          title: '最终转化率',
          key: 'ultimateConversionRate',
          width: 100,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const percent = Number(row.ultimateConversionRate * 100).toFixed(2)
            return h('span', `${percent}%`)
          }
        },
        {
          title: '待上门',
          key: 'waitVisitCnt',
          field: 'waitVisitCnt',
          width: 60,
          align: 'center'
        },
        {
          title: '已上门',
          key: 'visitedCnt',
          field: 'visitedCnt',
          width: 60,
          align: 'center'
        },
        {
          title: '有方案',
          key: 'hasSchemeCnt',
          field: 'hasSchemeCnt',
          width: 80,
          align: 'center'
        },
        {
          title: '审批中',
          key: 'reviewingCnt',
          field: 'reviewingCnt',
          width: 80,
          align: 'center'
        },
        {
          title: '通过',
          key: 'approvedCnt',
          field: 'approvedCnt',
          width: 60,
          align: 'center'
        },
        {
          title: '放款',
          key: 'issuedCnt',
          field: 'issuedCnt',
          width: 80,
          align: 'center'
        },
        {
          title: '回款',
          key: 'commissionCnt',
          field: 'commissionCnt',
          width: 80,
          align: 'center'
        },
        {
          title: '批复金额(元)',
          key: 'approvedAmountTotal',
          width: 150,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('span', formatMoney(Number(row.approvedAmountTotal).toFixed(0)));
          }
        },
        {
          title: '放款金额(元)',
          key: 'issuedAmountTotal',
          width: 150,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('span', formatMoney(Number(row.issuedAmountTotal).toFixed(0)));
          }
        },
        {
          title: '待放款金额(元)',
          key: 'waitIssueAmountTotal',
          width: 150,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('span', formatMoney(Number(row.approvedAmountTotal - row.issuedAmountTotal).toFixed(0)));
          }
        },
        {
          title: '上门率',
          key: 'visitedRate',
          width: 120,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('span', `${Number(row.visitedRate * 100).toFixed(2)}%`);
          }
        },
        {
          title: '方案率',
          key: 'hasSchemeRate',
          width: 120,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('span', `${Number(row.hasSchemeRate * 100).toFixed(2)}%`);
          }
        },
        {
          title: '进件率',
          key: 'reviewingRate',
          width: 120,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('span', `${Number(row.reviewingRate * 100).toFixed(2)}%`);
          }
        },
        {
          title: '批复率',
          key: 'approvedRate',
          width: 120,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('span', `${Number(row.approvedRate * 100).toFixed(2)}%`);
          }
        },
        {
          title: '件均(元)',
          key: 'avgAmount',
          width: 150,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('span', formatMoney(Number(row.issuedAmountAvg).toFixed(0)));
          }
        },
        {
          title: '实际点位(%)',
          key: 'commissionPoint',
          width: 120,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('span', `${Number(row.commissionPoint * 100).toFixed(2)}%`);
          }
        },
        {
          title: '回款金额(元)',
          key: 'commitAmountTotal',
          width: 150,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('span', formatMoney(Number(row.commissionAmountTotal).toFixed(0)));
          }
        }
      ]
    }
  }
}
</script>
